import type { CofSessionStats } from '@tunasong/music-lib'
import { Button } from '@tunasong/ui-lib'
import type { FC } from 'react'
import styles from './cof-wheel-summary.module.css'

export interface CofWheelSummaryProps {
  stats: CofSessionStats
  onRestart: () => void
  onSwitchToExplore: () => void
}

/**
 * CoF Wheel v1 quiz summary — final score + per-kind breakdown + restart.
 *
 * Spec: docs/superpowers/specs/2026-05-23-cof-wheel-v1-design.md §9
 */
export const CofWheelSummary: FC<CofWheelSummaryProps> = props => {
  const { stats, onRestart, onSwitchToExplore } = props
  return (
    <section className={styles.panel} aria-label="Quiz summary">
      <h2 className={styles.heading}>Quiz complete</h2>
      <p className={styles.score}>
        {stats.correct} / {stats.total}
      </p>
      <ul className={styles.breakdown}>
        <li>
          Find the relative: {stats.byKind['find-relative'].correct} / {stats.byKind['find-relative'].total}
        </li>
        <li>
          Find a closely-related key: {stats.byKind['find-closely-related'].correct} /{' '}
          {stats.byKind['find-closely-related'].total}
        </li>
      </ul>
      <div className={styles.actions}>
        <Button variant="contained" onClick={onRestart}>
          Restart
        </Button>
        <Button variant="outlined" onClick={onSwitchToExplore}>
          Back to Explore
        </Button>
      </div>
    </section>
  )
}
